import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ButtonList, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Fragment, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useClickAway } from 'react-use';
import { useBreakpointValue } from 'utils/mediaQuery';
import { Item } from './components/menuItem';
import { useSettingsMenu } from './hooks/useSettingsMenu';
import styles from './menu.module.scss';
export function Menu() {
    var _a;
    const menu = useSettingsMenu();
    const { pathname } = useLocation();
    const firstAccessibleItem = (_a = menu[0]) === null || _a === void 0 ? void 0 : _a.items[0];
    const currentLocationMenuItem = menu
        .reduce((menu, { items }) => [...menu, ...items], [])
        .find(({ route }) => pathname.includes(route));
    const [activeItem, setActiveItem] = useState(currentLocationMenuItem || firstAccessibleItem);
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const [isExpanded, setIsExpanded] = useState(!isSmallScreen);
    const menuRef = useRef(null);
    useClickAway(menuRef, () => {
        if (isSmallScreen && isExpanded) {
            setIsExpanded(false);
        }
    });
    function renderItem(item) {
        const { segmentId, route } = item;
        const isItemActive = activeItem.segmentId === segmentId;
        return (_jsx(Item, { item: item, isItemActive: isItemActive, setActiveItem: setActiveItem }, route));
    }
    function renderCategory({ title, items }, index) {
        return (_jsxs(Fragment, { children: [title && !isSmallScreen && (_jsx("li", Object.assign({ className: classnames(styles.menuTitle, styles.menuItemControl) }, { children: title }))), items.map(renderItem)] }, index));
    }
    return (_jsx("div", Object.assign({ ref: menuRef, className: classnames(styles.menuWrapper, {
            [styles.menuWrapperExpanded]: isExpanded,
        }) }, { children: _jsxs(ButtonList, Object.assign({ className: styles.buttonList }, { children: [isSmallScreen && (_jsx(ButtonList.Item, Object.assign({ icon: isExpanded ? 'angle-double-left' : 'angle-double-right', onClick: () => setIsExpanded(!isExpanded), buttonClassName: classnames(styles.menuItem, styles.menuItemControl), "data-testid": `menu-expander` }, { children: _jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: isExpanded ? 'Collapse' : _jsx(_Fragment, { children: "\u00A0" }) })) }))), menu.map(renderCategory)] })) })));
}
